import script from "./BlogDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogDetailView.vue?vue&type=script&setup=true&lang=js"

import "./BlogDetailView.vue?vue&type=style&index=0&id=a09cf3a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a09cf3a6"]])

export default __exports__